import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    id: "reports",
    class: "admin-table"
};
const _hoisted_2 = { class: "colored-row" };
const _hoisted_3 = { class: "w-16 relative pb-10 whitespace-nowrap" };
const _hoisted_4 = ["aria-labelledby"];
const _hoisted_5 = { class: "hidden lg:flex absolute z-10 bottom-0" };
const _hoisted_6 = { class: "flex text-xs pb-3" };
const _hoisted_7 = { class: "flex font-bold items-center ml-2 rounded-xl bg-brand-600 text-white px-1 shadow" };
const _hoisted_8 = {
    key: 0,
    class: "flex text-xs pb-3 ml-6"
};
const _hoisted_9 = { class: "pb-10" };
const _hoisted_10 = ["id"];
const _hoisted_11 = { class: "text-left pb-10" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { class: "w-2/6 pb-10" };
const _hoisted_14 = {
    key: 0,
    class: "pt-1 w-full"
};
const _hoisted_15 = { class: "flex mb-2 items-center" };
const _hoisted_16 = { class: "flex-1 justify-start" };
const _hoisted_17 = { class: "flex justify-end" };
const _hoisted_18 = {
    key: 1,
    class: "text-center p-3"
};
const _hoisted_19 = {
    key: 2,
    class: "text-center p-3"
};
const _hoisted_20 = { class: "font-medium pb-10" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" };
const _hoisted_23 = {
    class: "text-lg leading-6 font-medium text-slate-900",
    id: "modal-title"
};
const _hoisted_24 = { class: "mb-3 text-sm" };
const _hoisted_25 = { class: "text-slate-600 text-sm my-3" };
const _hoisted_26 = { class: "font-bold text-brand-blue-900" };
const _hoisted_27 = { class: "font-bold text-brand-blue-900" };
const _hoisted_28 = { class: "font-bold text-brand-blue-900" };
const _hoisted_29 = { class: "my-3 h-56 overflow-y-scroll" };
const _hoisted_30 = { class: "flex" };
const _hoisted_31 = { class: "flex-1 py-3 w-2/3 flex items-center" };
const _hoisted_32 = { class: "text-slate-700 text-sm ml-2 font-medium" };
const _hoisted_33 = { class: "py-3 w-1/3 text-right" };
const _hoisted_34 = ["href"];
const _hoisted_35 = { class: "my-loading" };
const _hoisted_36 = { class: "no-results panel p-10 mt-4" };
const _hoisted_37 = { class: "text-slate-600 font-medium text-2xl text-center" };
const _hoisted_38 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    const _component_ConfirmationModal = _resolveComponent("ConfirmationModal");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.index.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Report Name / Parameters"),
                                        _createElementVNode("th", { scope: "col" }, "Status"),
                                        _createElementVNode("th", { scope: "col" }, "Progress"),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (report) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                            _createElementVNode("td", _hoisted_3, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": report.uuid
                                                }, [...(_cache[4] || (_cache[4] = [
                                                        _createElementVNode("title", null, "Report Job", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_4)),
                                                _createElementVNode("div", _hoisted_5, [
                                                    _createElementVNode("ul", _hoisted_6, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("li", { class: "ml-6 uppercase font-medium text-slate-600" }, "Parameters", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(report.formatted_parameters, (param) => {
                                                            return (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(param.name) + " " + _toDisplayString(param.value), 1));
                                                        }), 256))
                                                    ]),
                                                    (!report.formatted_parameters)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_9, [
                                                _createElementVNode("span", {
                                                    class: "block font-medium",
                                                    id: report.uuid
                                                }, _toDisplayString(report.report_name), 9, _hoisted_10),
                                                _createElementVNode("span", null, "Requested on " + _toDisplayString(_ctx.f.formatDate(report.created_at)) + " by " + _toDisplayString(report.authenticatable_name), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_11, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-box", {
                                                            'status-open': report.status === 'scheduled',
                                                            'status-processing with-ping': report.status === 'running',
                                                            'status-complete': report.status === 'complete',
                                                            'status-cancelled': report.status === 'failed',
                                                        }])
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(report.status), 1),
                                                    (report.status === 'running')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [...(_cache[6] || (_cache[6] = [
                                                                _createElementVNode("span", null, null, -1),
                                                                _createElementVNode("span", null, null, -1)
                                                            ]))]))
                                                        : _createCommentVNode("", true)
                                                ], 2)
                                            ]),
                                            _createElementVNode("td", _hoisted_13, [
                                                ((report.status === 'complete' || report.status === 'running' || report.status === 'scheduled') && report.total > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _createElementVNode("div", _hoisted_16, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["text-xs font-medium inline-block py-1 px-2 uppercase rounded-full", { 'text-slate-800 bg-slate-200': _ctx.isJobComplete(report.status), 'text-error-600 bg-error-100': !_ctx.isJobComplete(report.status) }])
                                                                }, _toDisplayString(report.processed.toLocaleString()) + " / " + _toDisplayString(report.total.toLocaleString()), 3)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_17, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["text-xs font-medium inline-block", { 'text-brand-800': _ctx.isJobComplete(report.status), 'text-error-600': !_ctx.isJobComplete(report.status) }])
                                                                }, _toDisplayString(_ctx.computeCompletionPercentage(report.processed, report.total)) + " % ", 3)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["overflow-hidden h-2 mb-4 text-xs flex rounded", { 'bg-slate-200': _ctx.isJobComplete(report.status), 'bg-error-200': !_ctx.isJobComplete(report.status) }])
                                                        }, [
                                                            _createElementVNode("div", {
                                                                style: _normalizeStyle(`width:${_ctx.computeCompletionPercentage(report.processed, report.total)}%`),
                                                                class: _normalizeClass(["shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center", { 'bg-error-900': _ctx.isJobComplete(report.status), 'bg-error-500': !_ctx.isJobComplete(report.status) }])
                                                            }, null, 6)
                                                        ], 2)
                                                    ]))
                                                    : (report.status === 'failed')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[7] || (_cache[7] = [
                                                                _createElementVNode("p", { class: "text-pink-600 font-semibold" }, " Report Failed ", -1),
                                                                _createElementVNode("p", { class: "font-normal text-slate-600 text-xs" }, " The report failed to process, please contact support. ", -1)
                                                            ]))]))
                                                        : (report.status === 'complete')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[8] || (_cache[8] = [
                                                                    _createElementVNode("p", { class: "text-pink-600 font-semibold" }, " Report contained no results ", -1),
                                                                    _createElementVNode("p", { class: "font-normal text-slate-600 text-xs" }, " Please try altering the report parameters to include a wider range of results. ", -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", _hoisted_20, [
                                                (report.status === 'complete')
                                                    ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
                                                        key: 0,
                                                        buttonClass: "dark",
                                                        buttonText: "Download Results",
                                                        onConfirmAction: _cache[0] || (_cache[0] = ($event) => (_ctx.index.resetQueueExport())),
                                                        onOpenModal: ($event) => (_ctx.index.getQueueExport(report.uuid)),
                                                        onCloseModal: _cache[1] || (_cache[1] = ($event) => (_ctx.index.resetQueueExport()))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_ctx.index.export)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                                    _createElementVNode("div", _hoisted_22, [
                                                                        _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.index.export.name), 1),
                                                                        _createElementVNode("p", _hoisted_24, " Requested on " + _toDisplayString(_ctx.f.formatDate(_ctx.index.export.date)), 1),
                                                                        _createElementVNode("p", _hoisted_25, [
                                                                            _cache[9] || (_cache[9] = _createTextVNode(" This report contains ", -1)),
                                                                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.index.export.total.toLocaleString()), 1),
                                                                            _cache[10] || (_cache[10] = _createTextVNode(" results and has been split into ", -1)),
                                                                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.index.export.urls.length.toLocaleString()), 1),
                                                                            _cache[11] || (_cache[11] = _createTextVNode(" file(s). Each file contains a chunk of ", -1)),
                                                                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.index.export.chunk_limit.toLocaleString()), 1),
                                                                            _cache[12] || (_cache[12] = _createTextVNode(" results. ", -1))
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_29, [
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.export.urls, (file) => {
                                                                                return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                                                    _createElementVNode("div", _hoisted_31, [
                                                                                        _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            class: "h-6 w-6",
                                                                                            fill: "none",
                                                                                            viewBox: "0 0 24 24",
                                                                                            stroke: "currentColor",
                                                                                            focusable: "false",
                                                                                            role: "img",
                                                                                            "aria-label": "See Download Report"
                                                                                        }, [
                                                                                            _createElementVNode("path", {
                                                                                                "stroke-linecap": "round",
                                                                                                "stroke-linejoin": "round",
                                                                                                "stroke-width": "2",
                                                                                                d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                                                            })
                                                                                        ], -1)),
                                                                                        _createElementVNode("span", _hoisted_32, _toDisplayString(file.name), 1)
                                                                                    ]),
                                                                                    _createElementVNode("div", _hoisted_33, [
                                                                                        _createElementVNode("a", {
                                                                                            href: file.url,
                                                                                            class: "btn text-sm"
                                                                                        }, "Download Report", 8, _hoisted_34)
                                                                                    ])
                                                                                ]));
                                                                            }), 256))
                                                                        ])
                                                                    ])
                                                                ]))
                                                                : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["onOpenModal"]))
                                                    : _createCommentVNode("", true),
                                                _cache[14] || (_cache[14] = _createElementVNode("span", null, "   ", -1))
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Loading, { message: "Loading Pending Reports" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#reports",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            })
                        ])
                    ], -1)),
                    _createElementVNode("h2", _hoisted_37, "No " + _toDisplayString(_ctx.index.name) + " Available", 1),
                    _createElementVNode("p", _hoisted_38, [
                        _createTextVNode(" We could not find any " + _toDisplayString(_ctx.index.name) + ", ", 1),
                        (_ctx.index.pending)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.navigationTo('complete')), ["prevent"]))
                            }, "show completed reports"))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.navigationTo('index')), ["prevent"]))
                            }, "run a report")),
                        _cache[17] || (_cache[17] = _createTextVNode(". ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
